// Pedido.js
import React from 'react';

const Pedido = () => {
  return <div>Pedido Page</div>;
};

export default Pedido;
